import React, { useContext, useState } from 'react'
import { motion } from 'framer-motion'
import { PokemonContext} from '../Context/PokemonContext'

function Search() {
  const [isActive, setIsActive] = useState(false)
  const [searchValue, setSearchValue] = useState('')

  const {pokemonList, setPokemonList, setReset} = useContext(PokemonContext)

  const variants = {
    open: { opacity: 1},
    closed: { opacity: 0},
  }

  const inputVariants = {
    open: { paddingLeft: '32px', opacity: 1},
    closed: { paddingLeft: '10px'},
  }

  const handleFilter = (e) => {
    setSearchValue((prev) => e.target.value)
    console.log(e.target.value)
    const filterText = e.target.value.toLowerCase(); // convert input to lowercase for case-insensitive comparison
    const new_list = pokemonList.filter((pokemon) => 
      pokemon.name.toLowerCase().includes(filterText)
    );
    setPokemonList(new_list)
  }

  const handleReset = (e) => {
    setReset(searchValue)
    setSearchValue('')
  }

  return (
    <label className='rounded-full  h-[32px] w-[280px] bg-white relative '>
        <motion.svg
          animate={isActive ? "open" : "closed"}
          variants={variants}
          transition={{ duration: 0.2, delay: .2, ease: "linear", }}
         className='absolute opacity-0  top-1/2 transform -translate-y-1/2 left-3' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.9 13.6167L8.88333 9.6C8.55 9.88889 8.16111 10.1139 7.71667 10.275C7.27222 10.4361 6.8 10.5167 6.3 10.5167C5.1 10.5167 4.08333 10.1 3.25 9.26667C2.41667 8.43334 2 7.42778 2 6.25C2 5.07223 2.41667 4.06667 3.25 3.23334C4.08333 2.4 5.09444 1.98334 6.28333 1.98334C7.46111 1.98334 8.46389 2.4 9.29167 3.23334C10.1194 4.06667 10.5333 5.07223 10.5333 6.25C10.5333 6.72778 10.4556 7.18889 10.3 7.63334C10.1444 8.07778 9.91111 8.49445 9.6 8.88334L13.65 12.9C13.75 12.9889 13.8 13.1028 13.8 13.2417C13.8 13.3806 13.7444 13.5056 13.6333 13.6167C13.5333 13.7167 13.4111 13.7667 13.2667 13.7667C13.1222 13.7667 13 13.7167 12.9 13.6167ZM6.28333 9.51667C7.18333 9.51667 7.95 9.19723 8.58333 8.55834C9.21667 7.91945 9.53333 7.15 9.53333 6.25C9.53333 5.35 9.21667 4.58056 8.58333 3.94167C7.95 3.30278 7.18333 2.98334 6.28333 2.98334C5.37222 2.98334 4.59722 3.30278 3.95833 3.94167C3.31944 4.58056 3 5.35 3 6.25C3 7.15 3.31944 7.91945 3.95833 8.55834C4.59722 9.19723 5.37222 9.51667 6.28333 9.51667Z" fill="#DC0A2D"/>
        </motion.svg>
        <motion.input
        value={searchValue}
        onInput={(e) => handleFilter(e)}
        animate={isActive ? "open" : "closed"}
        variants={inputVariants}
        transition={{ duration: 0.2, delay: .1, ease: "linear", }}
        onMouseLeave={() => setIsActive(() => false)}
        onMouseEnter={() => setIsActive((prev) => !prev)}  type="text" className='pl-8 px-2 transition-all duration-150 bg-none shadow-[inset_0px_1px_3px_1px_#00000040] focus:shadow-[0px_1px_3px_1px_#00000040] rounded-full w-[280px] text-medium text-[16px] h-[32px] border-none focus:border-transparent focus:ring-0 focus:outline-none' placeholder='pokemon name' />

      <motion.svg 
      onClick={() => handleReset()}
      animate={isActive ? "open" : "closed"}
      variants={variants}
      transition={{ duration: 0.2, delay: .2, ease: "linear", }}
      className='absolute opacity-0 cursor-pointer  top-1/2 transform -translate-y-1/2 right-3'
      width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.9999 8.70002L4.4999 12.2C4.3999 12.3 4.28324 12.35 4.1499 12.35C4.01657 12.35 3.8999 12.3 3.7999 12.2C3.6999 12.1 3.6499 11.9834 3.6499 11.85C3.6499 11.7167 3.6999 11.6 3.7999 11.5L7.2999 8.00002L3.7999 4.50002C3.6999 4.40002 3.6499 4.28336 3.6499 4.15002C3.6499 4.01669 3.6999 3.90002 3.7999 3.80002C3.8999 3.70002 4.01657 3.65002 4.1499 3.65002C4.28324 3.65002 4.3999 3.70002 4.4999 3.80002L7.9999 7.30002L11.4999 3.80002C11.5999 3.70002 11.7166 3.65002 11.8499 3.65002C11.9832 3.65002 12.0999 3.70002 12.1999 3.80002C12.2999 3.90002 12.3499 4.01669 12.3499 4.15002C12.3499 4.28336 12.2999 4.40002 12.1999 4.50002L8.6999 8.00002L12.1999 11.5C12.2999 11.6 12.3499 11.7167 12.3499 11.85C12.3499 11.9834 12.2999 12.1 12.1999 12.2C12.0999 12.3 11.9832 12.35 11.8499 12.35C11.7166 12.35 11.5999 12.3 11.4999 12.2L7.9999 8.70002Z" fill="#DC0A2D"/>
      </motion.svg>


    </label>
  )
}

export default Search